import React from "react";
import Check from "@material-ui/icons/Check";

// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";

// styles
import { CheckboxContainerstyled } from "./styles";
import stylesCheckbox from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";

const useStylesCheckbox = makeStyles(stylesCheckbox);

const CheckboxList = ({ items, colorRGB }) => {
  const classesCheckbox = useStylesCheckbox({ color: colorRGB });

  return (
    <CheckboxContainerstyled>
      {items &&
        items.map((item, index) => {
          return (
            <React.Fragment key={`${item.title}-${index}`}>
              <span>{item.title}</span>
              <Checkbox
                checked={item.checkValue}
                checkedIcon={
                  <Check className={`${classesCheckbox.checkedIconCustom}`} />
                }
                icon={<Check className={classesCheckbox.uncheckedIconCustom} />}
                onClick={(e) => item.handler(e)}
                style={{
                  color: colorRGB,
                }}
                classes={{
                  checked: classesCheckbox.checked,
                  root: classesCheckbox.checkRoot,
                }}
              />
            </React.Fragment>
          );
        })}
    </CheckboxContainerstyled>
  );
};

export default React.memo(CheckboxList);
